import { Box } from '@mui/material';
import { useStyles } from './styles';
import { IBottomButtonsWrapperProps } from './interfaces';
import BasicButton from '@components/BasicButton';
import { NavigationArrowLeftIcon, NavigationArrowRightIcon } from '@icons';

const BottomButtonsWrapper = ({
  leftButtonClick,
  rightButtonClick,
  hideRightButton = false,
  hideLeftButton = false,
  leftButtonText = '',
  rightButtonText = '',
  leftButtonDisabled = false,
  rightButtonDisabled = false,
  rightButtonIsLoading = false,
  leftButtonIsArrow = false,
  rightButtonIsArrow = false,
}: IBottomButtonsWrapperProps) => {
  const classes = useStyles();

  if (hideLeftButton && hideRightButton) {
    return null;
  }

  return (
    <Box sx={classes.root}>
      {!hideLeftButton ? (
        leftButtonIsArrow ? (
          <Box
            sx={classes.circle(leftButtonDisabled)}
            onClick={() => {
              !leftButtonDisabled && leftButtonClick && leftButtonClick();
            }}
          >
            <NavigationArrowLeftIcon
              sx={classes.arrowIcon(leftButtonDisabled)}
            />
          </Box>
        ) : (
          <BasicButton disabled={leftButtonDisabled} onClick={leftButtonClick}>
            {leftButtonText}
          </BasicButton>
        )
      ) : (
        <Box component="span" />
      )}
      {!hideRightButton ? (
        rightButtonIsArrow ? (
          <Box
            sx={classes.circle(rightButtonDisabled)}
            onClick={() => {
              !rightButtonDisabled && rightButtonClick && rightButtonClick();
            }}
          >
            <NavigationArrowRightIcon
              sx={classes.arrowIcon(rightButtonDisabled)}
            />
          </Box>
        ) : (
          <BasicButton
            primary
            disabled={rightButtonDisabled}
            loading={rightButtonIsLoading}
            onClick={rightButtonClick}
          >
            {rightButtonText}
          </BasicButton>
        )
      ) : null}
    </Box>
  );
};

export default BottomButtonsWrapper;
